export type SectionItems = { title: BookTitle; link: string; chapters: number }[]

const oldTestament = [
  { title: "Genesis", link: "Genesis.html", chapters: 50 },
  { title: "Exodus", link: "Exodus.html", chapters: 40 },
  { title: "Leviticus", link: "Leviticus.html", chapters: 27 },
  { title: "Numbers", link: "Numbers.html", chapters: 36 },
  { title: "Deuteronomy", link: "Deuteronomy.html", chapters: 34 },
  { title: "Joshua", link: "Joshua.html", chapters: 24 },
  { title: "Sou Köpwüng", link: "Sou%20Kopwung.html", chapters: 21 },
  { title: "Ruth", link: "Ruth.html", chapters: 4 },
  { title: "1 Samuel", link: "1%20Samuel.html", chapters: 31 },
  { title: "2 Samuel", link: "2%20Samuel.html", chapters: 24 },
  { title: "1 King", link: "1%20King.html", chapters: 22 },
  { title: "2 King", link: "2%20King.html", chapters: 25 },
  { title: "1 Kronika", link: "1%20Kronika.html", chapters: 29 },
  { title: "2 Kronika", link: "2%20Kronika.html", chapters: 36 },
  { title: "Ezra", link: "Ezra.html", chapters: 10 },
  { title: "Nehemiah", link: "Nehemiah.html", chapters: 13 },
  { title: "Esther", link: "Esther.html", chapters: 10 },
  { title: "Job", link: "Job.html", chapters: 42 },
  { title: "Köölfel", link: "Koolfel.html", chapters: 150 },
  { title: "Proverbs", link: "Proverbs.html", chapters: 31 },
  { title: "Ekklesiastes", link: "Ekklesiastes.html", chapters: 12 },
  { title: "Än Solomon Kööl", link: "An%20Solomon%20Kool.html", chapters: 8 },
  { title: "Isaiah", link: "Isaiah.html", chapters: 66 },
  { title: "Jeremiah", link: "Jeremiah.html", chapters: 52 },
  { title: "Köölün Kechiw", link: "Koolun%20Kechiw.html", chapters: 5 },
  { title: "Ezekiel", link: "Ezekiel.html", chapters: 48 },
  { title: "Daniel", link: "Daniel.html", chapters: 12 },
  { title: "Hosea", link: "Hosea.html", chapters: 14 },
  { title: "Joel", link: "Joel.html", chapters: 3 },
  { title: "Amos", link: "Amos.html", chapters: 9 },
  { title: "Obadiah", link: "Obadiah.html", chapters: 1 },
  { title: "Jonah", link: "Jonah.html", chapters: 4 },
  { title: "Mika", link: "Mika.html", chapters: 7 },
  { title: "Nahum", link: "Nahum.html", chapters: 3 },
  { title: "Habakkuk", link: "Habakkuk.html", chapters: 3 },
  { title: "Zefaniah", link: "Zefaniah.html", chapters: 3 },
  { title: "Hakkai", link: "Hakkai.html", chapters: 2 },
  { title: "Zekariah", link: "Zekariah.html", chapters: 14 },
  { title: "Malakai", link: "Malakai.html", chapters: 4 },
] as const

const newTestament = [
  { title: "Matthew", link: "Matthew.html", chapters: 28 },
  { title: "Mark", link: "Mark.html", chapters: 16 },
  { title: "Luke", link: "Luke.html", chapters: 24 },
  { title: "John", link: "John.html", chapters: 21 },
  { title: "Föfför", link: "Foffor.html", chapters: 28 },
  { title: "Rom", link: "Rom.html", chapters: 16 },
  { title: "1 Korint", link: "1%20Korint.html", chapters: 16 },
  { title: "2 Korint", link: "2%20Korint.html", chapters: 13 },
  { title: "Kalatia", link: "Kalatia.html", chapters: 6 },
  { title: "Efisos", link: "Efisos.html", chapters: 6 },
  { title: "Filipai", link: "Filipai.html", chapters: 4 },
  { title: "Kolose", link: "Kolose.html", chapters: 4 },
  { title: "1 Tessalonika", link: "1%20Tessalonika.html", chapters: 5 },
  { title: "2 Tessalonika", link: "2%20Tessalonika.html", chapters: 3 },
  { title: "1 Timothy", link: "1%20Timothy.html", chapters: 6 },
  { title: "2 Timothy", link: "2%20Timothy.html", chapters: 4 },
  { title: "Titus", link: "Titus.html", chapters: 3 },
  { title: "Filimon", link: "Filimon.html", chapters: 1 },
  { title: "Hipru", link: "Hipru.html", chapters: 13 },
  { title: "James", link: "James.html", chapters: 5 },
  { title: "1 Peter", link: "1%20Peter.html", chapters: 5 },
  { title: "2 Peter", link: "2%20Peter.html", chapters: 3 },
  { title: "1 John", link: "1%20John.html", chapters: 5 },
  { title: "2 John", link: "2%20John.html", chapters: 1 },
  { title: "3 John", link: "3%20John.html", chapters: 1 },
  { title: "Jude", link: "Jude.html", chapters: 1 },
  { title: "Pwärätä", link: "Pwarata.html", chapters: 22 },
] as const

const sections: { section: SectionItems; title: BookTitle }[] = [
  { section: [...oldTestament], title: "Testamentin Lóm" },
  { section: [...newTestament], title: "Testament Sö Fö" },
]

const allBookTitles = [...oldTestament.map(b => b.title), ...newTestament.map(b => b.title)]
export type BookTitle = (typeof allBookTitles)[number] | "Testamentin Lóm" | "Testament Sö Fö"

export { sections, oldTestament, newTestament }
